export const c1 = {
  id: 1,
  title: "GENERATIVE",
  subtitle: "APARTMENT BUILDING",
  details: {
    type: "academic project",
    date: "06.2022",
    "co-authors": "experimental design attendees",
  },
  bigImgs: ["Comp/mieszkania-zmiana3.webp"],
  imgs: [],
  split: {
    img: "Comp/mieszkania-zmiana3.webp",
    desc: [
      "<b>Generative apartment block</b>",
      "Can architectural design be automated? This was the question for our team during the classes of Experimental Design.",
      "The automation covers all the steps from placement optimization to apartment layout and facade design. The script was designed to be used on various plot sizes and locations producing the results automatically. The task was completed using Rhino + Grasshopper programming.",
      "The team was divided into four subteams automating four stages of point block design – massing, floor divisions, apartment design and facade design. We’ve decided to treat this design process as semi-linear, meaning all the major steps happened one after another, yet most of them included some form of feedback-loop-driven optimization.",
      "As I participated mostly in work of the group D3, the following images are focusing on the apartments design.",
      "<b>To see the process for the whole building, please visit:<b>",
      "<a href='http://experimentaldesign2022.wordpress.com' target='blank'>experimentaldesign2022</a>",
    ],
  },
  topGif: "Comp/top-gif.webp",
  bottomImg: "Comp/Generated plans.jpg",
};
export const c2 = {
  id: 2,
  // title: "OTHER",
  subtitle: "For more computational projects contact me by email.",
  // details: {
  //   type: "academic project",
  //   date: "2021-2022",
  //   "co-authors": "other class attendees",
  // },
  desc: [
    "<b>Computational design</b>",
    "Simultaneously, I have got the chance to attend Digital Fabrication and Computational Design courses. We have designed a range of models and scripts including an organic lichens-inspired tile, optimization scripts and small acoustic panels.",
  ],
  panel: {
    img: "Comp/Panels.jpg",
    caption:
      "The process of digital design and fabrication of small acoustic panels",
  },
  anemones: {
    gifs: ["Comp/Anemone1.gif", "Comp/Anemone2.gif", "Comp/Anemone3.gif"],
    caption: "Anemone loop-based cell multiplication",
  },
};
